import { Message } from 'element-ui';

const mixin = {
  data() {
    return {
      checkInStatus: window.NxVetV2.RECORD_STATUS.CHECK_IN,
      inspectedStatus: window.NxVetV2.RECORD_STATUS.INSPECTED,
      dispensedStatus: window.NxVetV2.RECORD_STATUS.DISPENSED,
      checkOutStatus: window.NxVetV2.RECORD_STATUS.CHECK_OUT,

      archiveStatus: window.NxVetV2.archiveStatus,
      executionStatus: window.NxVetV2.executionStatus,

      erpOrderProcessStatus: window.NxErp.ORDER_PROCESS,
      erpOrderCompleteStatus: window.NxErp.ORDER_COMPLETE,
      erpOrderPlaceStatus: window.NxErp.ORDER_PLACE,

      drugRoundStatus: 1,
      drugRoundUpStatus: 2,
      drugRoundDownStatus: 3,

      billingTypeByCustomize: 2,
      billingTypeByDemand: 0,
      billingTypeByOnce: 1,

      images: {
        cat: require('@/assets/img_cat.png'),
        dog: require('@/assets/img_dog.png'),
      },
      staffDefaultColor: '#5F6368',

      affectNumericKeyCode: [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '.',
        '-',
        'Backspace',
      ],
    };
  },
  computed: {
    changeUsers() {
      return this.$store.state.change.users;
    },
    changeUsersDic() {
      return this.$store.state.change.usersDic;
    },
    changeStaffs() {
      return this.$store.state.change.staffs;
    },
    changePets() {
      return this.$store.state.change.pets;
    },
    changePetsDic() {
      return this.$store.state.change.petsDic;
    },
    changeSetting() {
      return this.$store.state.change.setting;
    },
    changeTreatmentSetting() {
      return this.$store.state.change.treatmentSetting;
    },
    changeRoles() {
      return this.$store.state.change.roles;
    },
    changeRecordBelongsStaff() {
      let activeStaff = this.$store.getters['change/activeStaff'];
      let hasRecordBelongsPermissionRole = this.changeRoles
        .filter((role) => role.permissions.indexOf('RECORD_BELONGS') > -1)
        .map((role) => role._id);
      let targetStaffs = activeStaff.filter((staff) => {
        return (
          staff.permission === 'admin' ||
          hasRecordBelongsPermissionRole.indexOf(staff.permissionDetail) > -1
        );
      });
      return targetStaffs;
    },
    changeDoctors() {
      let activeStaff = this.$store.getters['change/activeStaff'];
      let hasDoctorPermissionRole = this.changeRoles
        .filter((role) => role.permissions.indexOf('DOCTOR') > -1)
        .map((role) => role._id);
      let doctors = activeStaff.filter((staff) => {
        return (
          staff.permission === 'admin' ||
          hasDoctorPermissionRole.indexOf(staff.permissionDetail) > -1
        );
      });
      doctors.sort(
        (doctor1, doctor2) => parseInt(doctor1.createDateTime) - parseInt(doctor2.createDateTime)
      );
      return doctors;
    },
    changeAllDoctors() {
      let allStaff = this.$store.getters['change/allStaff'];
      let hasDoctorPermissionRole = this.changeRoles
        .filter((role) => role.permissions.indexOf('DOCTOR') > -1)
        .map((role) => role._id);
      let doctors = allStaff.filter((staff) => {
        return (
          staff.permission === 'admin' ||
          hasDoctorPermissionRole.indexOf(staff.permissionDetail) > -1
        );
      });
      doctors.sort(
        (doctor1, doctor2) => parseInt(doctor1.createDateTime) - parseInt(doctor2.createDateTime)
      );
      return doctors;
    },
    changeReminders() {
      return this.$store.state.change.reminders;
    },
    isInHospital2Usable() {
      return this.$store.getters['module/isInHospital2Usable'];
    },
    fileUploading() {
      return this.$store.state.header.uploading;
    },
  },
  filters: {
    commaFormat: function (value) {
      // 加上千分位符號
      if (!value) return '0';
      return value.toLocaleString();
    },
    percentFormat: function (value) {
      if (!value) return '';
      return `${(value * 100).toFixed(2)}%`;
    },
  },
  methods: {
    changeTimestampFormat(timestamp, separate = '-') {
      return window.dayjs.unix(timestamp).format(`YYYY${separate}MM${separate}DD`);
    },
    changeDateFormat(date) {
      return window.dayjs('20' + date).format('YYYY-MM-DD');
    },
    changeTimeFormat(time) {
      if (!time) return '00:00';
      return time.toString().substr(0, 2) + ':' + time.toString().substr(2, 2);
    },
    changeToTime(timestamp) {
      return window.dayjs.unix(timestamp).format('HH:mm');
    },
    changeToDate(dateTime) {
      return window.dayjs.unix(dateTime).format('YYYY/MM/DD');
    },
    changeToDateTime(dateTime) {
      return window.dayjs.unix(dateTime).format('YYYY/MM/DD HH:mm');
    },
    getStaffByPermission(filter) {
      let activeStaff = this.$store.getters['change/activeStaff'];
      let hasPermissionRole = this.changeRoles
        .filter((role) => role.permissions.indexOf(filter) > -1)
        .map((role) => role._id);
      let accounting = activeStaff.filter((staff) => {
        return (
          staff.permission === 'admin' || hasPermissionRole.indexOf(staff.permissionDetail) > -1
        );
      });
      accounting.sort(
        (acc1, acc2) => parseInt(acc1.createDateTime) - parseInt(acc2.createDateTime)
      );
      return accounting;
    },
    getNameWithStatus(name, status) {
      if (!name) return '';
      if (!status) return name;
      let petStatusList = window.NxVetV2.getPetStatusList();
      let returnName = name;
      petStatusList.forEach((petStatus) => {
        if (petStatus._id == status) {
          if (status != '0') {
            returnName = name + ' (' + petStatus.nametc + ')';
          }
        }
      });
      return returnName;
    },
    getLastWeight(pet) {
      if (pet.weightHistory && pet.weightHistory.length > 0) {
        pet.weightHistory.sort((history1, history2) => {
          return history2.dateTime - history1.dateTime;
        });
        return parseFloat(pet.weightHistory[0].value);
      } else {
        return '';
      }
    },
    getPetType(typeID, withTC, onlyTC) {
      let kinds = this.$store.state.customize.kind;
      let type = kinds.find((kind) => kind._id == typeID);
      let result = 'unknown'; // typeID;
      if (type) {
        result = `${type.name}${withTC ? ` (${type.nametc})` : ''}`;
        if (onlyTC) {
          result = type.nametc;
        }
      }
      return result;
    },
    getPetBreed(breedID, withTC, onlyTC) {
      let kindBreed = this.$store.state.customize.kindBreed;
      let breeds = [];
      kindBreed.forEach((kind) => {
        breeds = breeds.concat(kind.breed);
      });
      let type = breeds.find((breed) => breed._id == breedID);
      let result = 'unknown'; // breedID;
      if (type) {
        result = `${type.name}${withTC ? ` (${type.nametc})` : ''}`;
        if (onlyTC) {
          result = type.nametc;
        }
      }
      return result;
    },
    getGender(gender, withTC) {
      if (gender === 'Male') return `Male ${withTC ? ` (公)` : ''}`;
      if (gender === 'Female') return `Female ${withTC ? ` (母)` : ''}`;
      return '';
    },
    // calcAge: (date) => {
    //   if (!date) return "";
    //   date = window.dayjs(date);
    //   let diffMonth = window.dayjs().diff(date, "month");
    //   let year = Math.floor(diffMonth / 12);
    //   let month = Math.floor(diffMonth % 12);

    //   let diffDay = window.dayjs().diff(date, "day");
    //   let day = Math.floor(diffDay % 30.42);
    //   return `${year}y${month}m${day}d`;
    // },
    calcAge: (date, deathTime = null) => {
      if (!date) return '';
      let birth = new Date(date);
      let today = deathTime ? new Date(deathTime) : new Date();
      let year = today.getFullYear() - birth.getFullYear();
      let month = today.getMonth() - birth.getMonth();
      let day = today.getDate() - birth.getDate();
      if (month < 0) {
        year--;
        month = today.getMonth() + (12 - birth.getMonth());
      }
      if (day < 0) {
        month--;
        let monthDay = 31;
        let presentM = birth.getMonth() + 1;
        switch (presentM) {
          case 4:
          case 6:
          case 9:
          case 11:
            monthDay = 30;
            break;
          case 2:
            monthDay = 28;
            break;
        }
        day = today.getDate() + (monthDay - birth.getDate());
      }
      if (month < 0) {
        year--;
        month += 12;
      }
      return `${year}y${month}m${day}d`;
    },
    calcAgeNumber: (birthDate, deathTime = null) => {
      if (!birthDate) return 0;
      return (
        Math.round(
          ((deathTime ? new Date(deathTime) : new Date()) - new Date(birthDate).getTime()) /
            (365.25 * 24 * 60 * 60 * 100)
        ) / 10
      );
    },
    // calcBirthDate: (age) => {
    //   if (!age) return "";
    //   let BirthYear = window.dayjs().subtract(Math.floor(age), "year");
    //   let BirthDay = window
    //     .dayjs(BirthYear)
    //     .subtract(Math.floor(365 * (age % 1)), "day");

    //   return window.dayjs(BirthDay).format("YYYY-MM-DD");
    // },
    changeDataFormat(data) {
      let newData = [];
      data.forEach((el) => {
        newData.push({
          _id: el._id,
          name: el.nametc ? `${el.name} (${el.nametc})` : `${el.name}`,
          value: el.name,
        });
      });

      return newData;
    },
    filterEmpty(data) {
      return data.filter((d) => d.record);
    },
    isFiniteNumber(num) {
      return num !== '' && isFinite(num) && !isNaN(num);
    },
    onSuccessMsg: (msg = '', duration = 2000) => {
      return Message.success({
        message: msg,
        duration: duration,
      });
    },
    onErrorMsg: (msg = '', duration = 3000) => {
      return Message.error({
        message: msg,
        duration: duration,
      });
    },
    gaEvent: (action, event_category, event_label, value = 1) => {
      /*window.gtag("event", action, {
        event_category: event_category,
        event_label: event_label,
        value: value,
      });*/
    },
    startGuide() {
      let introJs = window
        .introJs()
        .setOptions({
          showBullets: false,
          showStepNumbers: false,
          showButtons: false,
          exitOnOverlayClick: false,
          overlayOpacity: 0.55,
        })
        .oncomplete(function () {
          document.querySelector('.introjs-overlay').removeEventListener('click', nextStep);

          window.VueApp.$alert(
            '<p>教學已完成，您可以開始使用！</p><p>如需再次觀看請點擊上方 "操作教學"</p>',
            '教學完成',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '確定',
            }
          );
        });

      introJs.start();

      document.querySelector('.introjs-overlay').addEventListener('click', nextStep);

      function nextStep() {
        introJs.nextStep();
      }
    },
    getDisableColor() {
      return { name: 'grey', code: '#9E9E9E', lighten1: '#BDBDBD' };
    },
    arrayCompare(array1, array2) {
      let _this = this;
      if (array1.length !== array2.length) {
        return false;
      }
      let eq = true;
      array1.forEach((element, index) => {
        if (
          eq &&
          typeof array1[index] === 'object' &&
          !_this.objCompare(array1[index], array2[index])
        ) {
          eq = false;
        } else if (eq && typeof array1[index] !== 'object' && array1[index] !== array2[index]) {
          eq = false;
        }
      });
      return eq;
    },
    objCompare(obj1 = {}, obj2 = {}) {
      if (obj1 === null) obj1 = {};
      if (obj2 === null) obj2 = {};

      let _this = this;
      //Loop through properties in object 1
      for (var p in obj1) {
        //Check property exists on both objects
        if (p === 'itemOrder' || p === 'createTaskDateTime') {
          obj1.itemOrder = obj2.itemOrder;
        }
        if (
          p === 'belongs' ||
          p === 'distribution' ||
          p === 'itemOrder' ||
          p === 'createTaskDateTime'
        )
          continue;

        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

        switch (typeof obj1[p]) {
          //Deep compare objects
          case 'object':
            // add compare for array
            if (Array.isArray(obj1[p])) {
              if (!_this.arrayCompare(obj1[p], obj2[p])) return false;
            } else {
              if (!_this.objCompare(obj1[p], obj2[p])) return false;
            }
            break;
          //Compare function code
          case 'function':
            if (
              typeof obj2[p] == 'undefined' ||
              (p != 'compare' && obj1[p].toString() != obj2[p].toString())
            )
              return false;
            break;
          //Compare values
          default:
            if (obj1[p] != obj2[p]) return false;
        }
      }

      //Check object 2 for any extra properties
      for (var p in obj2) {
        if (p === 'belongs' || p == 'distribution') continue;
        if (typeof obj1[p] == 'undefined') return false;
      }
      return true;
    },
    getDraftList() {
      let localStorages = Object.entries(localStorage);
      let localKeys = [];
      localStorages.forEach((ls) => {
        localKeys.push(ls[0]);
      });
      // console.log(JSON.stringify(localKeys));

      return localKeys.filter((key) => key.startsWith('RECORD_DRAFT'));
    },
  },
};

export default mixin;
